export default {
  "Log In": "Se connecter",
  "Sign Up": "S'inscrire",
  "Login to VideoViews": "Connectez-vous à VideoViews",
  "Enter your details below": "Entrez vos coordonnées ci-dessous",
  "Email address": "Adresse e-mail",
  "Password": "Mot de passe",
  "Forgot your password?": "Mot de passe oublié?",
  "Remember me": "Se souvenir de moi",
  "Don't have an account?": "Vous n'avez pas de compte ?",
  "Sign up for a free trial.": "Inscrivez-vous pour un essai gratuit.",

  "Create a new account": "Créer un nouveau compte",
  "Name": "Nom",
  "I accept the": "J'accepte",
  "Terms": "les conditions",
  "and": "et",
  "Privacy": "la confidentialité",
  "Register": "S'inscrire",
  "Already have an account?": "Vous avez déjà un compte?",
  "Login here.": "Connectez-vous ici.",

  "Resources": "Ressources",
  "Product support": "Support produit",
  "Request a demo": "Demander une démo",
  "Company": "Compagnie",
  "About Us": "À propos de nous",
  "Careers": "Carrières",
  "Follow Us": "Suivez-nous",
  "Partners & Sponsors": "Partenaires et commanditaires",
  "Terms of Use": "Conditions d'utilisation",
  "Privacy Policy": "Politique de confidentialité",
  "Cookie Policy": "Politique relative aux cookies",

  "Pricing": "Tarification",
  "VideoViews Pricing": "Tarification de VideoViews",
  "Free Tier": "Niveau Gratuit",
  "1 VideoViews Credit is provided for free upon registration. 1 Credit provides AI Video Content Analysis for 1 hour of video content.": "1 crédit VideoViews est fourni gratuitement lors de l’inscription. 1 Crédit permet l’analyse de contenu vidéo par IA pour 1 heure de contenu vidéo.",
  "Video Analysis": "Analyse Vidéo",
  "$5 USD per VideoViews Credit, 1 Credit provides AI Video Content Analysis for 1 hour of video content.": "5$ USD par crédit VideoViews, 1 Crédit permet l’analyse de contenu vidéo par IA pour 1 heure de contenu vidéo.",
  "Data Storage and Access": "Stockage de Données et Accès",
  "$10 USD per month + $0.50 USD per hour of video content after 20 hours. <br/>This allows you to view the content analysis result and search for content in your videos.": "10$ USD par mois + 0,50$ USD par heure de contenu vidéo après 20 heures. <br/>Cela vous permet de consulter le résultat de l’analyse de contenu et de rechercher du contenu dans vos vidéos.",

  "Upload": "Téléverser",
  "Search": "Recherche",
  "Account": "Compte",
  "Log Out": "Déconnexion",
  "Dark mode": "Mode sombre",
  "Light mode": "Mode clair",
  "Toggle dark mode": "Activer ou désactiver le mode sombre",

  "All": "Tout",
  "Processing": "En traitement",
  "Finished": "Terminé",
  "Error": "Erreur",
  "Library": "Bibliothèque",
  "Uploaded": "Téléversé",
  "Duration": "Durée",
  "Status": "Statut",
  "videos": "vidéos",
  "Rename": "Renomer",
  "Rename Folder": "Renomer le dossier",
  "Cancel": "Annuler",
  "Save": "Sauvegarder",
  "Folder Name": "Nom de dossier",
  "Edit": "Modifier",
  "Delete": "Supprimer",
  "Video Details": "Détails de la vidéo",
  "Video Name": "Nom de la vidéo",
  "Folder": "Dossier",
  "Not Processed": "Non traité",
  "New Folder": "Nouveau dossier",
  "Create Folder": "Créer un dossier",
  "Create": "Créer",
  "Filter by name": "Filtrer par nom",
  "No videos": "Aucune vidéo",
  "List": "Liste",
  "Detailed": "Détaillé",
  "Thumbnail": "Miniature",
  "Upload Thumbnail": "Téléverser une miniature",
  "Set frame as thumbnail": "Utiliser l'image comme miniature",
  "More": "Plus",

  "Drag and drop anywhere to upload": "Glissez et déposez n'importe où pour téléverser",
  "Maximum file size": "Taille maximale du fichier",
  "Supported formats": "Formats supportés",
  "or choose a file": "ou choisissez un fichier",
  "Preparing to upload": "Préparation du téléversement",
  "Uploading": "Téléchargement",
  "Desired Transcript Language": "Langue de transcription souhaitée",
  "Auto Detect": "Détection automatique",
  "English": "Anglais",
  "French": "Français",
  "Spanish": "Espagnol",
  "German": "Allemand",
  "Multi Language": "Multilingue",
  "Deselect features for faster processing time": "Désélectionnez les fonctionnalités pour un temps de traitement plus rapide",
  "Notify me when done processing": "M'avertir une fois le traitement terminé",
  "Credits remaining after upload": "Crédits restants après le téléchargement",
  "Insufficient credit": "Crédit insuffisant",
  "Please": "S'il vous plaît",
  "add credit": "ajouter du crédit",
  "refresh": "rafraîchir",
  "Save & Upload": "Enregistrer et télécharger",
  "Your video is being processed": "Votre vidéo est en cours de traitement",
  "When your upload is complete, we'll start parsing your file. Once that magical technological process is completed, your video will appear in your library.": "Une fois votre téléchargement terminé, nous commencerons à analyser votre fichier. Une fois ce processus technologique magique terminé, votre vidéo apparaîtra dans votre bibliothèque.",
  "Need help? If you are having trouble uploading, or you suspect that your upload has failed, please check your internet connection, make sure your video meets our compression guidlines, and the try uploading again.": "Besoin d'aide? Si vous rencontrez des difficultés pour télécharger ou si vous pensez que votre téléchargement a échoué, veuillez vérifier votre connexion Internet, assurez-vous que votre vidéo respecte nos directives de compression, puis réessayez de télécharger.",

  "Search for": "Rechercher",
  "Exclude": "Exclure",
  "Folders": "Dossier",
  "1 match": "1 correspondance",
  "{{count}} matches": "{{count}} correspondances",
  "1 video": "1 vidéo",
  "{{count}} videos": "{{count}} vidéos",
  "No results found": "Aucun résultat trouvé",

  "Find any moment by what’s said, who’s on screen or what’s seen": "Trouvez un moment par ce qui est dit, qui est à l'écran ou ce qu'on voit",
  "Describe the moment · @ to mention someone · \"quotes\" for exact words": "Décrivez le moment · @ pour mentionner quelqu'un · \"guillemets\" pour les mots exacts",
  "Search in": "Chercher dans",
  "All folders": "Tous les dossiers",
  "all folders": "tous les dossiers",
  "Only search videos in this folder. @ suggestions come from it too.": "Chercher seulement dans les vidéos de ce dossier. Les suggestions @ en viennent aussi.",
  "People in {{folder}}": "Personnes dans {{folder}}",
  "In 1 video": "Dans 1 vidéo",
  "In {{count}} videos": "Dans {{count}} vidéos",
  "No one matching “{{q}}” in {{folder}}": "Personne ne correspond à « {{q}} » dans {{folder}}",
  "Search all folders": "Chercher dans tous les dossiers",
  "↑ ↓ to choose · Enter to insert · Esc to close": "↑ ↓ pour choisir · Entrée pour insérer · Échap pour fermer",
  "Understood as": "Compris comme",
  "Press Enter to search": "Appuyez sur Entrée pour chercher",
  "Type @ to mention someone from {{folder}}": "Tapez @ pour mentionner quelqu'un de {{folder}}",
  "{{name}} speaking": "{{name}} parle",
  "Must be the one speaking": "Doit être la personne qui parle",
  "{{name}} on screen": "{{name}} à l'écran",
  "Only needs to be on screen": "Doit seulement être à l'écran",
  "said exactly “{{value}}”": "dit exactement « {{value}} »",
  "These exact words are said": "Ces mots exacts sont prononcés",
  "about “{{value}}”": "à propos de « {{value}} »",
  "Searched as a whole in what’s said and what happens": "Cherché en entier dans ce qui est dit et ce qui se passe",
  "Searching…": "Recherche en cours…",
  "Estimated search time ~{{seconds}} s": "Durée de recherche estimée ~{{seconds}}\u00a0s",
  "took {{seconds}} s": "en {{seconds}}\u00a0s",
  "Took {{seconds}} s": "Recherche effectuée en {{seconds}}\u00a0s",
  "{{moments}} in {{scenes}}, {{videos}}": "{{moments}} dans {{scenes}}, {{videos}}",
  "{{moments}} in {{videos}}": "{{moments}} dans {{videos}}",
  "on screen for {{duration}}": "à l'écran pendant {{duration}}",
  "1 moment": "1 moment",
  "{{count}} moments": "{{count}} moments",
  "No exact matches": "Aucune correspondance exacte",
  "Sort": "Trier",
  "Relevance": "Pertinence",
  "Video order": "Ordre des vidéos",
  "Show": "Afficher",
  "Matches": "Correspondances",
  "+ Related ({{count}})": "+ Proches ({{count}})",
  "Show 1 related moment": "Afficher 1 moment proche",
  "Show {{count}} related moments": "Afficher {{count}} moments proches",
  "The search didn’t work": "La recherche n'a pas fonctionné",
  "Try again in a moment.": "Réessayez dans un instant.",
  "Describe the moment you’re looking for": "Décrivez le moment que vous cherchez",
  "Mention people with @, then add what they say or what’s on screen.": "Mentionnez des personnes avec @, puis ajoutez ce qu'elles disent ou ce qu'on voit à l'écran.",
  "No moment in {{folder}} matches every part": "Aucun moment dans {{folder}} ne correspond à toute la phrase",
  "Some moments match part of the sentence.": "Certains moments correspondent à une partie de la phrase.",
  "Nothing in {{folder}} matches this": "Rien dans {{folder}} ne correspond",
  "Try fewer words, someone else, or search all folders.": "Essayez avec moins de mots, une autre personne, ou cherchez dans tous les dossiers.",
  "speech": "parole",
  "moment": "moment",
  "person": "personne",
  "related": "proche",
  "{{name}}:": "{{name}} :",
  "Matches:": "Résultats\u00a0:",
  "Previous moment": "Moment précédent",
  "Next moment": "Moment suivant",
  "Go to {{time}}": "Aller à {{time}}",
  "Moment {{i}} of {{n}}": "Moment {{i}} sur {{n}}",
  "How it matched": "Pourquoi ce résultat",
  "{{name}} said": "{{name}} a dit",
  "{{name}} is on screen": "{{name}} est à l'écran",
  "No transcript": "Aucune transcription",
  "Loading…": "Chargement…",

  "VideoViews Account": "Compte VideoViews",
  "Payment Methods": "Modes de payement",
  "VideoViews Credit": "Crédit VideoViews",
  "credits": "crédits",
  "Add Credits": "Ajouter des crédits",
  "Set Default": "Définir par defaut",
  "Remove": "Retirer",
  "Add payment method": "Ajouter un mode de paiement",

  "Checkout": "Commander",
  "VideoViews Credits": "Crédits VideoViews",
  "1 credit provides A.I Analysis": "1 crédit fournit une analyse IA",
  "for 1 hour of video content": "pour 1 heure de contenu vidéo",
  "Qty": "Qté",
  "per hours": "par heure",
  "VideoViews Data Storage and Access": "Stockage et accès aux données VideoViews",
  "Provides data storage and searchable access for video AI analysis results": "Fournit un stockage de données et un accès consultable aux résultats de l'analyse vidéo de l'IA",
  "month": "mois",
  "per hours over": "par heure après",
  "hours": "heures",
  "Buy": "Acheter",
  "Buy and Subscribe": "Acheter et s'abonner",

  "Home": "Accueil",
  "Preferred Email Language": "Langue d'e-mail préférée",
  "Change": "Changer",
  "Change Password": "Changer le mot de passe",
  "Current Password": "Mot de passe actuel",
  "New Password": "Nouveau mot de passe",

  "Subscription": "Abonnement",
  "video hours": "heures de vidéo",
  "Next invoice on": "Prochaine facture le",
  "Cancel Subscription": "Annuler l'abonnement",
  "Subscribe": "S'abonner",
  "of video": "de vidéo",

  "Saving Payment Method": "Enregistrement du mode de paiement",

  "Summary": "Sommaire",
  "Tracks": "Pistes",
  "Transcript": "Transcription",
  "Redaction": "Rédaction",
  "Queries": "Requêtes",
  "Clips": "Extraits",
  "Your": "Vos",
  "hour video usage is over the 1-hour free trial limit. To see this content, Subscribe or remove content.": "heures de vidéo dépasse la limite d'une heure d'essai gratuit. Pour voir ce contenu, abonnez-vous ou supprimez du contenu.",
  "Go Back": "Retourner",

  "Characters": "Personnages",
  "All Characters": "Tous les personnages",
  "Screen Time": "Temps à l'écran",
  "Speech time": "Temps de parole",
  "Co-occurrences": "Cooccurrences",
  "SCREEN TIME": "TEMPS À L'ÉCRAN",
  "SPEECH TIME": "TEMPS DE PAROLE",
  "SHARE OF RUNTIME": "PART DE LA DURÉE",
  "Cast report": "Rapport de distribution",
  "Speech Time": "Temps de parole",
  "Share of Runtime": "Part de la durée",
  "Speech Highlights": "Points saillants du discours",
  "LOCATIONS": "LIEUX",
  "NAMES": "NOMS",
  "ORGANIZATIONS": "ORGANISATIONS",
  "KEY PHRASES": "EXPRESSIONS-CLÉS",

  "Add": "Ajouter",
  "Character Tracks": "Pistes de personnages",
  "Suggested": "Suggéré",
  "Actor": "Acteur",
  "Choose character": "Choisir un personnage",
  "NEW CHARACTER": "NOUVEAU PERSONNAGE",
  "Confirm": "Confirmer",

  "Download": "Télécharger",
  "Download Best Frame": "Télécharger la meilleure image",
  "clips": "extraits",

  "SAVE": "SAUVEGARDER",
  "Character": "Personnage",
  "Object": "Objet",
  "Text": "Texte",
  "Drag over object to redact": "Faites glisser la souris sur l'objet à expurger",
  "Custom Object": "Objet personnalisé",
  "Pause video then drag over object to redact": "Mettez la vidéo en pause, puis faites glisser la souris sur l'objet pour supprimer",
  "AUDIBLE": "AUDIBLE",
  "MUTE": "COUPER",
  "BEEP": "BIP",
  "MASK": "MASQUE",
  "Redact": "Rédiger",
  "Redact video to clip": "Rédiger la vidéo en clip",
  "Redaction job started": "Le travail de rédaction a commencé",
  "View Clips": "Voir les clips",
  "All instances of the word": "Toutes les instances du mot",

  "Query builder": "Constructeur de requêtes",
  "New Query": "Nouvelle requête",
  "Launch Query": "Lancer la requête",
  "And": "Et",
  "Or": "Ou",
  "Group": "Groupe",
  "Include": "Inclure",
  "Face Posture": "Posture du visage",
  "Emotions": "Émotions",
  "Locations": "Lieux",
  "Scenes": "Scènes",
  "Speech": "Discours",
  "Value": "Valeur",
  "Key": "Clé",
  "Logo Name": "Nom du logo",
  "Logo Size": "Taille du logo",
  "Query Results": "Résultats de la requête",
  "segments found": "segments trouvés",
  "Extract": "Extraire",
  "Extract as clip": "Extraire en tant que clip",
  "Extract Name": "Nom de l'extrait",
  "Aspect Ratio": "Ratio d'aspect",
  "Original": "Original",
  "Landscape": "Paysage",
  "Portrait": "Portrait",
  "Square": "Carré",
  "Padding": "Rembourrage",
  "Download best frame": "Télécharger la meilleure image",
  "segments selected": "segments sélectionnés",
  "Extraction job started": "Travail d'extraction démarré",
  "Back": "Retour",

  "Content": "Contenu",
  "Search scenes, people, places": "Rechercher des scènes, des personnes, des lieux",
  "Search transcript": "Rechercher dans la transcription",
  "Clear": "Effacer",
  "{{time}} speech": "{{time}} de parole",
  "Story arcs": "Arcs narratifs",
  "Show this arc": "Afficher cet arc",
  "Show this character": "Afficher ce personnage",
  "Show top 6": "Afficher les 6 premiers",
  "Show top 5": "Afficher les 5 premiers",
  "Show all {{count}} story arcs": "Afficher les {{count}} arcs narratifs",
  "Show all {{count}} characters": "Afficher les {{count}} personnages",
  "Show all {{count}}": "Afficher les {{count}}",
  "Show less": "Afficher moins",
  "No scenes found": "Aucune scène trouvée",
  "Untitled scene": "Scène sans titre",
  "Scene": "Scène",
  "1 scene": "1 scène",
  "{{count}} scenes": "{{count}} scènes",
  "1 story arc": "1 arc narratif",
  "{{count}} story arcs": "{{count}} arcs narratifs",
  "1 character": "1 personnage",
  "{{count}} characters": "{{count}} personnages",
  "1 line": "1 ligne",
  "{{count}} lines": "{{count}} lignes",
  "shots": "plans",
  "transition": "transition",
  "Play scene": "Lire la scène",
  "Play from here": "Lire à partir d'ici",
  "Collapse": "Réduire",
  "Close": "Fermer",
  "Moments": "Moments",
  "Moment {{count}}": "Moment {{count}}",
  "Character beats": "Temps forts des personnages",
  "Outcome": "Dénouement",
  "Facts": "Faits",
  "attribute": "attribut",
  "relation": "relation",
  "reveal": "révélation",
  "role": "rôle",
  "Central": "Central",
  "Involved": "Impliqué",
  "Background": "Arrière-plan",
  "Setup": "Exposition",
  "Development": "Développement",
  "Turning point": "Tournant",
  "Climax": "Point culminant",
  "Resolution": "Résolution",
  "Cliffhanger at episode end": "Suspense en fin d'épisode",
  "Resolved at episode end": "Résolu en fin d'épisode",
  "Ongoing at episode end": "En cours en fin d'épisode",
  "Continues": "Se poursuit",
  "On screen": "À l'écran",
  "Speaking": "Parole",
  "central in {{count}}": "central dans {{count}}",
  "{{time}} on screen": "{{time}} à l'écran",
  "Story steps in order ({{count}})": "Étapes de l'histoire dans l'ordre ({{count}})",
  "Alcohol": "Alcool",
  "Blood or injury": "Sang ou blessure",
  "Death": "Mort",
  "Drug use": "Consommation de drogue",
  "Self-harm": "Automutilation",
  "Sexual content": "Contenu sexuel",
  "Smoking": "Tabac",
  "Strong language": "Langage grossier",
  "Violence": "Violence",
  "Weapon": "Arme",
  "Zoom in": "Zoom avant",
  "Zoom out": "Zoom arrière",
  "Fit": "Ajuster",
  "Show whole episode": "Afficher tout l'épisode",
  "Ctrl/⌘ + scroll to zoom · Shift + scroll to pan": "Ctrl/⌘ + molette pour zoomer · Maj + molette pour défiler",
  "Drag to pan": "Faire glisser pour défiler",
  "Resize the result list": "Redimensionner la liste des résultats",
  "Drag to resize columns · double-click to reset": "Faire glisser pour redimensionner les colonnes · double-cliquer pour réinitialiser",
  "Back to scenes": "Retour aux scènes",

  // Overview tab
  "Overview": "Aperçu",
  "Important Characters": "Personnages importants",
  "on screen": "à l'écran",
  "speaking": "parole",
  "Key moments": "Moments clés",
  "1 arc": "1 arc",
  "{{count}} arcs": "{{count}} arcs",
  "Main plot": "Intrigue principale",
  "Secondary plot": "Intrigue secondaire",
  "Minor thread": "Intrigue mineure",
  "No content flagged": "Aucun contenu signalé",
  "Show these scenes": "Afficher ces scènes",
  "Topics": "Sujets",
  "Places": "Lieux",
  "{{time}} runtime": "durée {{time}}",
  "No overview for this video yet": "Pas encore d'aperçu pour cette vidéo",
  "Open in Scenes": "Ouvrir dans Scènes",
  "Scripted drama": "Série dramatique",
  "Scripted comedy": "Comédie",
  "Feature film": "Long métrage",
  "Documentary": "Documentaire",
  "Factual entertainment": "Divertissement factuel",
  "Reality": "Téléréalité",
  "News": "Actualités",
  "Talk show": "Talk-show",
  "Game show": "Jeu télévisé",
  "Sport": "Sport",
  "Live event": "Événement en direct",
  "Presentation": "Présentation",
  "Commercial": "Publicité",
  "Other": "Autre",

  // Tracks tab
  "Find a character": "Trouver un personnage",
  "Screen time": "Temps à l'écran",
  "Track count": "Nombre de pistes",
  "Add Character": "Ajouter un personnage",
  "1 track": "1 piste",
  "{{count}} tracks": "{{count}} pistes",
  "{{count}} unnamed": "{{count}} sans nom",
  "Unnamed": "Sans nom",
  "Track order": "Ordre des pistes",
  "By time": "Chronologique",
  "Least similar first": "Moins ressemblantes d'abord",
  "Drag across tracks to select · Shift-click for a range · Drag a selection onto a character to move it": "Glissez sur les pistes pour les sélectionner · Maj-clic pour une plage · Glissez une sélection sur un personnage pour l'y déplacer",
  "Rename {{name}}": "Renommer {{name}}",
  "Add actor": "Ajouter un acteur",
  "Actor name": "Nom de l'acteur",
  "Select all tracks of {{name}}": "Sélectionner toutes les pistes de {{name}}",
  "More actions for {{name}}": "Plus d'actions pour {{name}}",
  "No tracks yet. Drag tracks here, or select tracks and choose Move To.": "Aucune piste. Glissez des pistes ici, ou sélectionnez des pistes et choisissez Déplacer vers.",
  "Show all {{count}} tracks": "Afficher les {{count}} pistes",
  "Less": "Moins",
  "Track at {{time}}": "Piste à {{time}}",
  "Move to another character": "Déplacer vers un autre personnage",
  "Delete track": "Supprimer la piste",
  "1 track selected": "1 piste sélectionnée",
  "{{count}} tracks selected": "{{count}} pistes sélectionnées",
  "from {{name}}": "de {{name}}",
  "from {{count}} characters": "de {{count}} personnages",
  "drag them onto a character, or choose Move To": "glissez-les sur un personnage ou choisissez Déplacer vers",
  "Clear selection": "Effacer la sélection",
  "New Character": "Nouveau personnage",
  "Move To": "Déplacer vers",
  "Merge Into": "Fusionner avec",
  "Move 1 track to": "Déplacer 1 piste vers",
  "Move {{count}} tracks to": "Déplacer {{count}} pistes vers",
  "Merge {{name}} into": "Fusionner {{name}} avec",
  "Current": "Actuel",
  "No characters match.": "Aucun personnage ne correspond.",
  "Select all tracks": "Sélectionner toutes les pistes",
  "Merge into…": "Fusionner avec…",
  "Delete character": "Supprimer le personnage",
  "Delete {{name}}?": "Supprimer {{name}} ?",
  "This can't be undone.": "Cette action est irréversible.",
  "Its tracks will move to {{name}}. This can't be undone.": "Ses pistes seront déplacées vers {{name}}. Cette action est irréversible.",
  "Deleted and unassigned tracks": "Pistes supprimées et non attribuées",
  "No deleted or unassigned tracks.": "Aucune piste supprimée ou non attribuée.",
  "1 track moved to {{name}}": "1 piste déplacée vers {{name}}",
  "{{count}} tracks moved to {{name}}": "{{count}} pistes déplacées vers {{name}}",
  "1 track moved to a new character": "1 piste déplacée vers un nouveau personnage",
  "{{count}} tracks moved to a new character": "{{count}} pistes déplacées vers un nouveau personnage",
  "1 track deleted": "1 piste supprimée",
  "{{count}} tracks deleted": "{{count}} pistes supprimées",
  "{{from}} merged into {{to}}": "{{from}} fusionné avec {{to}}",
  "{{name}} deleted": "{{name}} supprimé",
  "Undo": "Annuler",
  "No characters match “{{q}}”": "Aucun personnage ne correspond à « {{q}} »",
  "Try a character or actor name.": "Essayez un nom de personnage ou d'acteur.",
  "No characters yet.": "Aucun personnage pour l'instant.",

  // account tabs
  "Profile": "Profil",
  "Video Settings": "Paramètres vidéo",
  "AI Assistants": "Assistants IA",
  "Billing": "Facturation",
  "Profile saved": "Profil enregistré",
  "Password changed": "Mot de passe modifié",
  "Character Recognition": "Reconnaissance des personnages",
  "Celebrity Recognition for talking characters": "Reconnaissance des célébrités pour les personnages qui parlent",
  "Get Character Names from": "Obtenir les noms des personnages depuis",
  "All videos in account": "Toutes les vidéos du compte",
  "All videos in same folder": "Toutes les vidéos du même dossier",
  "Video itself only": "La vidéo seulement",
  "Upload Settings for Drag and Drop": "Paramètres de téléversement par glisser-déposer",
  "Features": "Fonctionnalités",
  "Actions": "Actions",
  "Logos": "Logos",
  "Nudity": "Nudité",
  "Connection Details": "Détails de connexion",
  "Add VideoViews as a custom connector (or custom MCP server) in your AI app, using the values below. Field names vary between apps": "Ajoutez VideoViews comme connecteur personnalisé (ou serveur MCP personnalisé) dans votre app d'IA, avec les valeurs ci-dessous. Le nom des champs varie selon l'app",
  "Any name you like": "Le nom de votre choix",
  "Only if asked, sometimes just HTTP": "Seulement si demandé, parfois simplement HTTP",
  "Authentication": "Authentification",
  "If your app asks how to sign in, choose No sign-in. Then add this header, and leave fields like “Bearer token env var” empty": "Si votre app demande comment se connecter, choisissez No sign-in. Ajoutez ensuite cet en-tête et laissez vides les champs comme « Bearer token env var »",
  "or Server URL": "ou URL du serveur",
  "or Transport": "ou Transport",
  "or Key": "ou Clé",
  "or Value": "ou Valeur",
  "Header name": "Nom de l'en-tête",
  "Bearer, a space, then your API key. Copy fills in the whole key": "Bearer, une espace, puis votre clé API. Copier insère la clé entière",
  "Type": "Type",
  "URL": "URL",
  "Header value": "Valeur de l'en-tête",
  "API key": "Clé API",
  "Create an API key first": "Créez d'abord une clé API",
  "API Keys": "Clés API",
  "Create API Key": "Créer une clé API",
  "Created {{date}}": "Créée le {{date}}",
  "No API keys yet": "Aucune clé API pour l'instant",
  "Copy": "Copier",
  "Delete Forever": "Supprimer définitivement",
  "Copied to clipboard": "Copié dans le presse-papiers",
  "Default": "Par défaut",
  "Expires {{date}}": "Expire {{date}}",
  "No payment methods yet": "Aucun mode de paiement pour l'instant",
  "Active": "Actif",
  "Video hours": "Heures de vidéo",
  "Monthly": "Mensuel",
  "Next invoice": "Prochaine facture",
  "Invoices": "Factures",
  "Date": "Date",
  "Amount": "Montant",
  "Invoice": "Facture",
  "Receipt": "Reçu",
  "No payments yet": "Aucun paiement pour l'instant",

  "Total": "Total",
  "per credit": "par crédit",
  "Fewer credits": "Moins de crédits",
  "More credits": "Plus de crédits",

  // usability fixes (Oct 2026)
  "Something went wrong on this page": "Un problème est survenu sur cette page",
  "Reload the page, or go back to your library.": "Rechargez la page, ou retournez à votre bibliothèque.",
  "Reload": "Recharger",
  "Go to the library": "Aller à la bibliothèque",
  "This search can’t be run": "Cette recherche ne peut pas être lancée",
  "Try rephrasing it with fewer words.": "Reformulez-la avec moins de mots.",
  "Try fewer words, or someone else.": "Essayez avec moins de mots, ou une autre personne.",
  "{{count}} characters left": "{{count}} caractères restants",
  "Open at {{time}}": "Ouvrir à {{time}}",
  "{{count}} of {{total}} scenes": "{{count}} scènes sur {{total}}",
  "1 shot": "1 plan",
  "{{count}} shots": "{{count}} plans",
  "Hide characters without lines": "Masquer les personnages sans réplique",
  "Show 1 character without lines": "Afficher 1 personnage sans réplique",
  "Show {{count}} characters without lines": "Afficher {{count}} personnages sans réplique",
  "{{count}} named": "{{count}} nommés",
  "Length": "Durée",
  "{{time}} long": "Durée {{time}}",

  // Ask
  "Ask": "Demander",
  "about your videos": "sur vos vidéos",
  "Ask about your videos": "Posez une question sur vos vidéos",
  "Ask a follow-up": "Posez une autre question",
  "What would you like to know about your videos?": "Que voulez-vous savoir sur vos vidéos ?",
  "Ask about people, topics and moments across your library. Answers link to the moments they come from.": "Posez des questions sur les personnes, les sujets et les moments de votre bibliothèque. Les réponses renvoient aux moments d’où elles viennent.",
  "Message": "Message",
  "Esc to stop": "Échap pour arrêter",
  "Enter to send · Shift + Enter for a new line": "Entrée pour envoyer · Maj + Entrée pour aller à la ligne",
  "Stop": "Arrêter",
  "Send": "Envoyer",
  "Chats": "Discussions",
  "Show chats": "Afficher les discussions",
  "Hide chats": "Masquer les discussions",
  "New Chat": "Nouvelle discussion",
  "Chat history": "Historique des discussions",
  "Chat title": "Titre de la discussion",
  "Today": "Aujourd’hui",
  "Yesterday": "Hier",
  "Previous 7 days": "7 derniers jours",
  "Older": "Plus anciennes",
  "Answering…": "Réponse en cours…",
  "Delete this chat?": "Supprimer cette discussion ?",
  "“{{title}}” and its answers will be deleted.": "« {{title}} » et ses réponses seront supprimés.",
  "Answer": "Réponse",
  "Play {{video}} at {{time}}": "Lire {{video}} à {{time}}",
  "Copied": "Copié",
  "Retry": "Réessayer",
  "Moment": "Moment",
  "{{shown}} of {{total}} matches": "{{shown}} correspondances sur {{total}}",
  "Show all {{count}} matches": "Afficher les {{count}} correspondances",
  "Show fewer": "Afficher moins",
  "all your videos": "toutes vos vidéos",
  "Searched transcripts in {{scope}} for {{words}}": "Recherche de {{words}} dans les transcriptions de {{scope}}",
  "Searching transcripts in {{scope}} for {{words}}": "Recherche de {{words}} dans les transcriptions de {{scope}}",
  "Searched transcripts for {{words}}": "Recherche de {{words}} dans les transcriptions",
  "Searched {{scope}} for {{words}}": "Recherche de {{words}} dans {{scope}}",
  "Searching {{scope}} for {{words}}": "Recherche de {{words}} dans {{scope}}",
  "Searched for {{words}}": "Recherche de {{words}}",
  "{{search}}, said by {{people}}": "{{search}}, dit par {{people}}",
  "{{search}}, with {{people}}": "{{search}}, avec {{people}}",
  "Read the lines of {{people}} in {{scope}}": "Lecture des répliques de {{people}} dans {{scope}}",
  "Reading the lines of {{people}} in {{scope}}": "Lecture des répliques de {{people}} dans {{scope}}",
  "Read the lines of {{people}}": "Lecture des répliques de {{people}}",
  "Looked for {{people}} in {{scope}}": "Recherche de {{people}} dans {{scope}}",
  "Looking for {{people}} in {{scope}}": "Recherche de {{people}} dans {{scope}}",
  "Looked for {{people}}": "Recherche de {{people}}",
  "No matches": "Aucune correspondance",
  "{{matches}} in {{videos}}": "{{matches}} dans {{videos}}",
  "Searched your videos for {{words}}": "Recherche de {{words}} dans vos vidéos",
  "Searching your videos for {{words}}": "Recherche de {{words}} dans vos vidéos",
  "Listed your videos": "Liste de vos vidéos",
  "Listing your videos": "Liste de vos vidéos",
  "Read the overview of {{video}}": "Lecture de l’aperçu de {{video}}",
  "Reading the overview of {{video}}": "Lecture de l’aperçu de {{video}}",
  "Read the scenes of {{video}}": "Lecture des scènes de {{video}}",
  "Reading the scenes of {{video}}": "Lecture des scènes de {{video}}",
  "Read the matching segments": "Lecture des passages trouvés",
  "Reading the matching segments in {{video}}": "Lecture des passages trouvés dans {{video}}",
  "Read the transcript of {{video}}": "Lecture de la transcription de {{video}}",
  "Reading the transcript of {{video}}": "Lecture de la transcription de {{video}}",
  "Looked at {{video}}": "Visionnage de {{video}}",
  "Looking at {{video}}": "Visionnage de {{video}}",
  "1 frame": "1 image",
  "{{count}} frames": "{{count}} images",
  "Searched the web for {{words}}": "Recherche de {{words}} sur le Web",
  "Searching the web for {{words}}": "Recherche de {{words}} sur le Web",
  "1 result": "1 résultat",
  "{{count}} results": "{{count}} résultats",
  "Read {{site}}": "Lecture de {{site}}",
  "Reading {{site}}": "Lecture de {{site}}",
  "Ran code": "Exécution de code",
  "Running code": "Exécution de code",
  "Used {{tool}}": "Utilisation de {{tool}}",
  "Using {{tool}}": "Utilisation de {{tool}}",
  "Didn’t work": "N’a pas fonctionné",
  "Stopped": "Arrêtée",
  "Writing the answer…": "Rédaction de la réponse…",
  "Thinking…": "Réflexion…",
  "Looking at your question…": "Lecture de votre question…",
  "The question couldn’t be sent: try again.": "La question n’a pas pu être envoyée : réessayez.",
  "This chat doesn’t exist anymore": "Cette discussion n’existe plus",
  "This chat couldn’t be loaded": "Cette discussion n’a pas pu être chargée",
  "Start a new chat": "Commencer une nouvelle discussion",
  "Reload the page, or try again in a moment.": "Rechargez la page, ou réessayez dans un instant.",
  // the API's errors of an answer (chat_runs.py)
  "Something went wrong: try again.": "Un problème est survenu : réessayez.",
  "The answer stopped before it was done.": "La réponse s’est arrêtée avant la fin.",
  "Your session has expired: log in again.": "Votre session a expiré : reconnectez-vous.",
  "The assistant couldn't answer this: try again.": "L’assistant n’a pas pu répondre : réessayez.",
  "Too many questions at once: try again in a moment.": "Trop de questions à la fois : réessayez dans un instant.",
  "The assistant isn't available: try again in a moment.": "L’assistant n’est pas disponible : réessayez dans un instant.",

  "": "",
};

/*
import { Trans, withTranslation } from "react-i18next";
withTranslation()(

<Trans></Trans>
{<Trans></Trans>}


*/
